<template>
  <div
    class="video-item"
    :class="{ 'video-item--dark': dark }"
    @click="$emit('click', video)"
  >
    <div class="video-item__thumbnail">
      <figure class="image is-4by3 is-unselectable">
        <img :src="thumbnail" />
        <div class="video-item__thumbnail__play is-hidden-touch">
          <icon name="fa-play" />
        </div>
      </figure>
    </div>
    <div class="video-item__info is-unselectable">
      <p class="video-item__info__title">{{ video.title }}</p>
    </div>
  </div>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "video-item",

  components: {
    Icon
  },

  props: {
    video: Object,
    dark: Boolean
  },

  computed: {
    thumbnail() {
      return process.env.VUE_APP_THUMBNAIL_MIN_URL + this.video.thumbnailPath;
    }
  }
};
</script>

<style lang="scss" scoped>
.video-item {
  display: flex;
  cursor: pointer;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  &__thumbnail {
    flex: 0 0 7rem;
    position: relative;

    &__play {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      background: transparentize($black, 0.7);
      font-size: 1.5rem;
      opacity: 0;
      transition: 0.3s;
    }
  }

  &__info {
    padding-left: 0.5rem;

    &__title {
      font-size: 0.85rem;
      font-weight: 500;
      font-family: $family-sans-serif-condensed;

      @include touch {
        font-size: 0.7rem;
      }

      @include until($small-mobile) {
        font-size: 0.8rem;
      }
    }
  }

  &:hover {
    .video-item__thumbnail__play {
      opacity: 1;
      transition: 0.3s;
    }

    .video-item__info__title {
      color: $grey;
    }
  }

  &--dark {
    .video-item__info {
      &__title {
        color: $grey-light;
      }
    }

    &:hover {
      .video-item__info__title {
        color: $grey-lighter;
      }
    }
  }
}
</style>
